import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'
type Platform = 'sensors'

interface IdataSet {
  index: number | string
  pageId: string
  propsConfig: { explosiveList: [] }
}

interface IactItem {
  redirect: any
  title: string
}

export function createTrackConfig() {
  return {
    poizon_venue_component_content_click(platform: Platform, dataSet: IdataSet) {
      if ((window as any).editorFlag === 'edit') return
      if (platform !== 'sensors') return
      const actItem: IactItem = dataSet.propsConfig.explosiveList[+dataSet.index]
      const component_content_id =
        actItem.redirect.landType === '2'
          ? new URLSearchParams(actItem.redirect.query).get('spuId')
          : ''
      let component_content_url = ''
      if (actItem.redirect.landType === '1') {
        component_content_url = actItem.redirect.href
      }
      if (actItem.redirect.landType === '2') {
        component_content_url = `/sell/productDetail?${actItem.redirect.query}`
      }
      return {
        current_page: 82,
        block_type: 88,
        venue_id: dataSet.pageId,
        venue_title: document.title,
        component_content_id,
        component_content_title: actItem.title,
        component_content_position: +dataSet.index + 1,
        component_content_url,
        poizon_component_type: 'poizon-explosiveBigPicture',
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },

    poizon_venue_component_content_exposure(platform: Platform, dataSet: IdataSet) {
      if ((window as any).editorFlag === 'edit') return
      if (platform !== 'sensors') return
      const actItem: IactItem = dataSet.propsConfig.explosiveList[+dataSet.index]
      const component_content_id =
        actItem.redirect.landType === '2'
          ? new URLSearchParams(actItem.redirect.query).get('spuId')
          : ''
      let component_content_url = ''
      if (actItem.redirect.landType === '1') {
        component_content_url = actItem.redirect.href
      }
      if (actItem.redirect.landType === '2') {
        component_content_url = `/sell/productDetail?${actItem.redirect.query}`
      }
      return {
        current_page: 82,
        block_type: 88,
        venue_id: dataSet.pageId,
        venue_title: document.title,
        component_content_info_list: JSON.stringify([
          {
            component_content_id,
            component_content_title: actItem.title,
            component_content_position: +dataSet.index + 1,
            component_content_url,
            poizon_component_type: 'poizon-explosiveBigPicture',
          },
        ]),
        poizon_component_type: 'poizon-explosiveBigPicture',
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },
  }
}
